import { createApp } from "petite-vue";
import { createIcons, icons } from "lucide";
import 'lite-youtube-embed';
import Navigation from "./services/navigation"; // Keep existing nav logic if complex, or replace
import StickyNav from "./services/sticky-nav";
import ContactForm from "./services/contact-form";
import ChatForm from "./services/chat-form";
import AnimationService from "./services/animations";

// Initialize Lucide Icons
createIcons({ icons });

// Initialize Global Animations (GSAP)
const animService = AnimationService();
animService.init();

// Mount Petite-Vue Apps

// Contact Form
if (document.querySelector('[v-scope="ContactForm()"]')) {
  createApp({ ContactForm }).mount("#contact");
}

// Chat Form
createApp({ ChatForm }).mount("#chat");

// Navigation (Mobile Toggle + Sticky)
if (document.querySelector('[v-scope="StickyNav"]')) {
     // If you want to combine the old Navigation logic with StickyNav, do it here.
     // For now, I'll assume StickyNav replaces the sticky logic and Navigation handles the menu toggle?
     // The user said "move vanilla js into petite-vue". The old Navigation module likely handled mobile toggle.
     // I'll mount them together or separately.
     // Let's inspect the `nav.partial.php` again to see what scope it uses.
     // It uses `id="navbar"`.
     createApp({ StickyNav }).mount("#navbar");
}

// If there was an old navigation mount point #navigation, keep it or check if it exists.
if (document.querySelector('#navigation')) {
  createApp({ Navigation }).mount("#navigation");
}
